<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>离线时平均体力</span>
        </div>
        <el-form ref="queryForm" :model="queryParams" :inline="true">
          <el-form-item label="日期" prop="startDate">
            <el-date-picker
              v-model="dateList"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column label="等级" align="center">
            <template slot-scope="{row,$index}">{{ row.level }}</template>
          </el-table-column>
          <el-table-column v-for="date in queryParams.dateList" :label="date" align="center">
            <template slot-scope="{row,$index}">{{ row[date] }}</template>
          </el-table-column>
        </el-table>

      </el-card>
    </template>

  </BasicLayout>
</template>

<script>

import {DatePickerOptions, getDiffDate} from "@/api/date";
import {offlineAvgSpin} from "@/api/statistics/event/event";

export default {
  name: 'offlineavgspin',
  data() {
    return {
      pickerOptions: DatePickerOptions,
      queryParams: {
        dateList: [],
      },
      loading: false,
      tableData: [],
      dateList: [],
    }
  },
  created() {
    this.dateList = [new Date(), new Date()]
    this.handleQuery()
  },
  methods: {
    fetchData() {
      offlineAvgSpin(this.queryParams).then(response=>{
        let data = [];
        let maxLevel = response.data.maxLevel
        for (let i = 1; i <= maxLevel; i++) {
          let tmp = { level: i }
          for (const date in response.data.list) {
            if(response.data.list[date][i] == null){
              tmp[date] = "没有该等级离线记录"
            }else{
              tmp[date] = response.data.list[date][i].toFixed(2)
            }
          }
          data.push(tmp)
        }
        this.tableData = data
      })
    },
    handleQuery() {
      this.queryParams.dateList = getDiffDate(this.dateList[0],this.dateList[1])
      this.fetchData()
    }
  }
}
</script>

<style scoped>
</style>
